import * as React from 'react';

const TelevisionSmall = () => (
  <svg
    width={50}
    height={46}
    viewBox="0 0 50 46"
    strokeWidth={1}
    fillRule="evenodd"
    stroke="#1C1F34"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path
      stroke="none"
      fill="#FFFFFF"
      d="M46.689,8.5 L4.249,8.5 C3.007,8.5 2,9.507 2,10.749 L2,39.189 C2,40.431 3.007,41.438 4.249,41.438 L46.689,41.438 C47.931,41.438 48.938,40.431 48.938,39.189 L48.938,10.749 C48.938,9.507 47.931,8.5 46.689,8.5 Z"
    />
    <path
      stroke="none"
      fill="#677BC5"
      d="M35.035,12.925 C36.458,21.144 36.458,29.363 35.035,37.583 C25.546,38.816 16.056,38.816 6.567,37.583 C5.144,29.363 5.144,21.144 6.567,12.925 C16.056,11.692 25.546,11.692 35.035,12.925 Z"
    />
    <path
      strokeWidth={2}
      d="M35.035,12.925 C25.546,11.692 16.056,11.692 6.567,12.925 C5.144,21.144 5.144,29.363 6.567,37.583 C16.056,38.816 25.546,38.816 35.035,37.583 C36.458,29.363 36.458,21.144 35.035,12.925 Z"
    />
    <path
      strokeWidth={2}
      d="M46.689,8.5 L4.249,8.5 C3.007,8.5 2,9.507 2,10.749 L2,39.189 C2,40.431 3.007,41.438 4.249,41.438 L46.689,41.438 C47.931,41.438 48.938,40.431 48.938,39.189 L48.938,10.749 C48.938,9.507 47.931,8.5 46.689,8.5 Z"
    />
    <polygon stroke="none" fill="#D6D7E0" points="8.298 44.126 4.5 44.126 4 41.5 8.798 41.5" />
    <polygon strokeWidth={2} points="8.298 44.126 4.5 44.126 4 41.5 8.798 41.5" />
    <path strokeWidth={2} d="M1,44.25 L49,44.25" />
    <polygon stroke="none" fill="#D6D7E0" points="46.798 44.126 43 44.126 42.5 41.5 47.298 41.5" />
    <polygon strokeWidth={2} points="46.798 44.126 43 44.126 42.5 41.5 47.298 41.5" />
    <polygon points="40 37.643 44.844 37.643 44.844 29.5 40 29.5" />
    <path d="M44.844,22.922 C44.844,21.584 43.76,20.5 42.422,20.5 C41.084,20.5 40,21.584 40,22.922 C40,24.259 41.084,25.344 42.422,25.344 C43.76,25.344 44.844,24.259 44.844,22.922 Z" />
    <path d="M44.844,15.422 C44.844,14.085 43.76,13 42.422,13 C41.084,13 40,14.085 40,15.422 C40,16.759 41.084,17.844 42.422,17.844 C43.76,17.844 44.844,16.759 44.844,15.422 Z" />
    <polyline points="23.905 12.5 23.905 15.46 22 18.427 22.953 20.523 22.953 23.402 25.509 25.366 27.081 20.523 30.179 19.523" />
    <polyline points="35.857 22 31.623 22.952 29.401 25.374 25.5 25.374 27.284 29.122 31.2 30.607 30.171 33.977 31.729 37.547" />
    <polygon stroke="none" fill="#1C1F34" points="27.91 29.247 30.027 25 25.5 25.273" />
    <polyline points="13.979 37.572 13.479 34.903 12.5 34.5" />
    <path d="M30.252,13 L29.5,14.215" />
    <path d="M27,6.921 L32.41,1" />
    <path
      stroke="none"
      fill="#1C1F34"
      d="M33.309,1.155 C33.309,0.517 32.791,0 32.154,0 C31.517,0 31,0.517 31,1.155 C31,1.792 31.517,2.309 32.154,2.309 C32.791,2.309 33.309,1.792 33.309,1.155"
    />
    <path d="M24.41,6.921 L19,1" />
    <path
      stroke="none"
      fill="#1C1F34"
      d="M18,1.155 C18,0.517 18.517,0 19.154,0 C19.792,0 20.308,0.517 20.308,1.155 C20.308,1.792 19.792,2.309 19.154,2.309 C18.517,2.309 18,1.792 18,1.155"
    />
    <path
      stroke="none"
      fill="#FFFFFF"
      d="M28.407,7.704 C28.407,6.763 27.197,6 25.703,6 C24.21,6 23,6.763 23,7.704"
    />
    <path
      strokeWidth={2}
      d="M28.407,8.204 C28.407,6.987 27.197,6 25.703,6 C24.21,6 23,6.987 23,8.204"
    />
  </svg>
);

export default TelevisionSmall;



// WEBPACK FOOTER //
// ./src/assets/images/icons/television-small.js